import React from 'react';
import Add from '@material-ui/icons/AddCircleOutline';
import IconButton from '@material-ui/core/IconButton';
import axios from '../../../../config/axiosInstance';


export const fieldsConfig = (phoneMask, departments, offices, cepMask, setNewItemConfig, setvalidateCpf) => [
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'name',
      label: 'Nome',
      required: true,
    },
    helperText: ' ',
  },
  {
    elementType: 'maskedInput',
    config: {
      type: 'text',
      name: 'cpf',
      label: 'CPF',
      // mask: [],
      mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      required: true,
    },
    helperText: setvalidateCpf === "" ? 'Coloque um CPF valido' : 'CPF valido!',
  },
  {
    elementType: 'maskedInput',
    config: {
      type: 'text',
      name: 'phone',
      label: 'Telefone',
      required: true,
      mask: phoneMask,
    },
    helperText: ' ',
  },
  {
    elementType: 'select',
    config: {
      name: 'departmentId',
      label: 'Departamento',
      icon: (
        <IconButton
          aria-label="Adicionar cargo"
          component="span"
          onClick={() => setNewItemConfig('departamento')}
          style={{ color: '#537CCD', padding: '6px', marginTop: '3px' }}
        >
          <Add />
        </IconButton>
      ),
      required: true,
      options: departments.map(department => ({
        value: department.id,
        displayValue: department.name,
      })),
    },
    helperText: ' ',
  },
  {
    elementType: 'select',
    config: {
      name: 'officeId',
      label: 'Cargo',
      icon: (
        <IconButton
          aria-label="Adicionar cargo"
          component="span"
          onClick={() => setNewItemConfig('cargo')}
          style={{ color: '#537CCD', padding: '6px', marginTop: '3px' }}
        >
          <Add />
        </IconButton>
      ),
      required: true,
      options: offices.map(office => ({
        value: office.id,
        displayValue: office.name,
      })),
    },
    helperText: ' ',
  },
  {
    elementType: 'datePicker',
    config: {
      name: 'admission',
      label: 'Data de Admissão',
      required: true,
      isFormik: true,
    },
    helperText: ' ',
  },
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'pisCode',
      label: 'PIS',
      required: false,
    },
    helperText: ' ',
  },
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'enrollment',
      label: 'Matrícula',
    },
    helperText: ' ',
  },
  {
    elementType: 'maskedInput',
    config: {
      type: 'text',
      name: 'postalCode',
      label: 'Cep',
      mask: cepMask,
      required: false,
    },
    helperText: ' ',
  },
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'address',
      label: 'Endereço',
      required: false,
    },
    helperText: ' ',
  },
  {
    elementType: 'autocomplete',
    config: {
      type: 'text',
      name: 'workplace',
      label: 'Local de Atuação',
      required: false,
      searchFunction: term => axios.get(`static/locations/keyWords/${term}`),
      instruction: 'Busque por estado ou municipio',
    },
    helperText: ' ',
  },
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'emailContact',
      label: 'Email de contato',
    },
    helperText: ' ',
  },
];
